import React, { useCallback } from 'react'
import { Divider } from 'antd'
// import PropTypes from 'prop-types'
import { PlusOutlined } from '@ant-design/icons'

function DropdownItemAction({
  menu = null,
  icon = <PlusOutlined />,
  title = '',
  onClick = () => {},
  rightContent,
  withExtra = true,
}) {
  const mouseDownHandler = useCallback((e) => e.preventDefault(), [])
  return (
    <div style={{ marginBottom: 8 }}>
      {menu}
      <Divider style={{ margin: rightContent ? '4px 0 8px' : '4px 0' }} />
      {rightContent ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 8px',
          }}
        >
          {withExtra && (
            <a href="#" onMouseDown={mouseDownHandler} onClick={onClick}>
              {icon} {title}
            </a>
          )}
          <div style={{ marginLeft: 'auto' }}>{rightContent}</div>
        </div>
      ) : (
        <a href="#" onMouseDown={mouseDownHandler} onClick={onClick} style={{ marginLeft: 8 }}>
          {icon} {title}
        </a>
      )}
    </div>
  )
}

// DropdownItemAction.propTypes = {
//   menu: PropTypes.node,
//   icon: PropTypes.object,
//   title: PropTypes.string,
//   onClick: PropTypes.func,
// }

// DropdownItemAction.defaultProps = {
//   menu: null,
//   icon: <PlusOutlined />,
//   title: '',
//   onClick: () => {},
// }

export default DropdownItemAction
